<template>
  <div data-testid="impact-kennzahl-detail">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <div>
        <p class="text-[13px] font-semibold text-[var(--color-dark)] mb-3 m-0">
          {{ $t('UserProjects.impactAnalysis.kennzahl.ppcTitle') }}
        </p>
        <CockpitPpcTrendChart :bars="ppcBars" />
        <p class="text-[12px] text-[var(--color-disabled)] mt-2 mb-0">
          {{ $t('UserProjects.impactAnalysis.kennzahl.targetGap', {
            target: targetPercent,
            gap: targetGapLabel,
          }) }}
        </p>
        <p class="text-[12px] text-[var(--color-disabled)] mb-0">
          n={{ ppcCurrent?.n ?? 0 }} · {{ periodLabel }}
        </p>
      </div>

      <div>
        <p class="text-[13px] font-semibold text-[var(--color-dark)] mb-3 m-0">
          {{ $t('UserProjects.impactAnalysis.kennzahl.milestonesTitle') }}
        </p>
        <div v-if="!milestones.length" class="text-[13px] text-[var(--color-disabled)]">
          {{ $t('UserProjects.impactAnalysis.kennzahl.emptyMilestones') }}
        </div>
        <div v-else class="space-y-1">
          <div
            v-for="milestone in milestones"
            :key="milestone.id"
            class="flex items-center gap-3 py-2 px-2 rounded"
            :class="{ 'bg-[#FAFAFA]': milestone.isCurrent }"
          >
            <span
              class="text-[16px] shrink-0 w-4 text-center"
              :style="{ color: statusColor(milestone) }"
            >
              {{ statusIcon(milestone) }}
            </span>
            <span
              class="text-[13px] flex-1 min-w-0 truncate text-[var(--color-dark)]"
              :class="milestone.isCurrent ? 'font-bold' : 'font-medium'"
            >
              {{ milestone.title }}
            </span>
            <span class="text-[12px] text-[var(--color-disabled)] shrink-0">
              {{ formatDate(milestone.dueDate) }}
            </span>
          </div>
        </div>
        <router-link
          to="/user-projects/milestones"
          class="text-[12px] font-medium no-underline hover:underline mt-2 inline-block text-[#6B6B6B]"
        >
          {{ $t('UserProjects.impactAnalysis.kennzahl.viewAllMilestones') }}
        </router-link>
      </div>
    </div>

    <div class="mt-5">
      <ImpactInterfaceQualityPanel :interface-quality="interfaceQuality" />
    </div>
  </div>
</template>

<script>
import CockpitPpcTrendChart from '@/components/CustomerApp/UserProjects/Cockpit/CockpitPpcTrendChart.vue';
import ImpactInterfaceQualityPanel from './ImpactInterfaceQualityPanel.vue';
import {
  formatShortDate,
  formatSignedDelta,
  milestoneStatusColor,
  milestoneStatusIcon,
} from '@/utils/impactAnalysisDisplay';

export default {
  name: 'ImpactKennzahlDetail',
  components: { CockpitPpcTrendChart, ImpactInterfaceQualityPanel },
  props: {
    ppcBars: { type: Array, default: () => [] },
    ppcCurrent: { type: Object, default: null },
    targetPercent: { type: Number, default: 80 },
    targetGap: { type: Number, default: null },
    milestones: { type: Array, default: () => [] },
    periodLabel: { type: String, default: '' },
    interfaceQuality: { type: Object, default: null },
  },
  computed: {
    targetGapLabel() {
      return formatSignedDelta(this.targetGap, '%') || '—';
    },
  },
  methods: {
    formatDate: formatShortDate,
    statusIcon: milestoneStatusIcon,
    statusColor: milestoneStatusColor,
  },
};
</script>
